import { ProgressStatusName } from '@/queries/progress-statuses/progress-statuses.enum';

// Every status except Starter unlocks the referral program.
export const isReferralUnlockedStatus = (statusName?: string | null): boolean =>
  !!statusName
  && statusName !== ProgressStatusName.Starter
  && Object.values<string>(ProgressStatusName).includes(statusName);
